var map = {
	"./logo_ag.png": "Ev/A",
	"./logo_bb.png": "4pdl",
	"./logo_ob.png": "CS9f",
	"./logo_og.png": "kiwO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "A/22";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/video ^\.\/logo_.*\.png$
// module id = A/22
// module chunks = 3